import { t } from 'i18next';
import React, { useState } from 'react';
import styled from 'styled-components';
import colors from '../../../theme/colors';
import Typography from '../typography/Typography';

interface ComponentProps {
    handleRemoveFile: () => void;
    style?: any;
    size?: number;
}

const IconContainer = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const Icon = styled.label`
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    margin-bottom: 4px;
    height: 38px;
    width: 38px;

    transition: all 0.5s;

    &:hover {
        cursor: pointer;
        background-color: ${props => props.theme.colors.inputBackground};
    }

    &:active {
        background-color: ${props => props.theme.colors.border};
    }
`;

const DeleteIcon: React.FC<ComponentProps> = ({handleRemoveFile, style, size=24}) => {

    return (
        <IconContainer style={style} onClick={handleRemoveFile}>
            <Icon>
                <svg width={size} height={size} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5589 18.1498L3.88475 4.66663H20.1156L19.4414 18.1498C19.3616 19.7464 18.0438 21 16.4452 21H7.55516C5.95654 21 4.63873 19.7464 4.5589 18.1498Z" stroke="#14142B" strokeWidth="2"/>
                    <path d="M8.4165 4.5H15.5832V3C15.5832 1.89543 14.6877 1 13.5832 1H10.4165C9.31193 1 8.4165 1.89543 8.4165 3V4.5Z" stroke="#14142B" strokeWidth="2"/>
                    <path d="M1.9165 4.58337H22.0832" stroke={colors.secondary} strokeWidth="2" strokeLinecap="round"/>
                    <path d="M14.75 10.0834V14.6667" stroke={colors.secondary} strokeWidth="2" strokeLinecap="round"/>
                    <path d="M9.25 10.0834V14.6667" stroke={colors.secondary} strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </Icon>
            <Typography type="paragraphXS" color="title">{t('remove')}</Typography>
        </IconContainer>
    )
}

export default DeleteIcon;